import React from "react";

import { GuideUserStatus } from "@mapmycustomers/shared/types/entity";

import ShowGuideOptions from "@app/types/ShowGuideOptions";

// The slot: an entry in `visibility`, true while its owner is on screen. The announcements modal
// holds this one while it is open or about to open, so every guide start sees it as a guide.
export const ANNOUNCEMENTS_GUIDE_ID = "mmc-announcements";

export interface IGuidesService {
  getCompletionPath: (slug: string) => string | undefined; // where to return on guide completion
  getGuideStatus(slug: string): GuideUserStatus | undefined;
  hideGuide(slug: string): void;
  showGuide(slug: string, options: ShowGuideOptions): boolean; // false when the mode refuses the start
  updateGuideStatus(status: GuideUserStatus): void;
  visibility: Record<string, boolean>;
}

const GuidesContext = React.createContext<IGuidesService>({
  getCompletionPath() {
    return undefined;
  },
  getGuideStatus() {
    return undefined;
  },
  hideGuide() {
    // nothing
  },
  showGuide() {
    return false;
  },
  updateGuideStatus() {
    // nothing
  },
  visibility: {},
});

export default GuidesContext;
